module.exports = __webpack_public_path__ + "static/media/slack.b956f85d.png";